import React, { useEffect, useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import { fechaHoraAmPm } from "../../../../utils/fechaHoraAmPm";
import { useUnaALaVez } from "../../../../utils/unaALaVez";
import { serverError } from "../../../../components/modals/payments/register/registerPaymentModal";
import { Dato, Seccion, Sub, Ventana } from "../promoApplications/detallePromo";
import { monto } from "../promoApplications/formato";
import { AUDIENCIAS, CopiarPromo, TIPO_NOMBRE, frase, payloadActivar, tipoDe, toDraft } from "./editorPromo";
import { LA_DA, Vigencia, valorTexto } from "./formatoCatalogo";

/*
	La ventana de una promo del Catálogo (como detallePromo de Promociones): «Así Queda», los datos, el uso de 30 días, la guía y el
	historial en una línea por cambio; abajo Cambiar, Copiar y Desactivar (o Activar). Desactivar = lo mismo que abrir el editor,
	quitar «Activa» y guardar con el motivo (PUT promotions/{id}, payloadActivar).
*/

const http = HttpManager.getInstance();
type Promo = any;
const ACCION: Record<string, string> = { crear: "Creada", editar: "Cambiada", migrar: "Cargada", desactivar: "Desactivada", activar: "Activada" };

const Historial: React.FC<{ campusId: number; promo: Promo; sym: string }> = ({ campusId, promo, sym }) => {
	const [list, setList] = useState<any[] | null>(null);
	useEffect(() => { http.paymentService.promotionHistory(campusId, promo.id).then((r: any) => setList(r.data || [])).catch(() => setList([])); }, [campusId, promo.id, promo.version, promo.active]);
	if (list === null) return <div className="loader" />;
	if (!list.length) return <div className="wpmSub">Sin Cambios</div>;
	return <>{list.map((h) => {
		const cambio = h.before && h.after && h.before.value !== undefined && h.after.value !== undefined && valorTexto(h.before, sym) !== valorTexto(h.after, sym)
			? valorTexto(h.before, sym) + " → " + valorTexto(h.after, sym) : "";
		const activa = !["activar", "desactivar"].includes(h.action) && h.before && h.after && h.before.active !== undefined && h.after.active !== undefined && h.before.active !== h.after.active ? (h.after.active ? "Activada" : "Desactivada") : "";
		const quien = (h.by || "").trim() || (h.action === "migrar" ? "Sistema (Migración)" : "Sistema");
		return (
			<div key={"h" + h.id} className="wpmEvento">
				<span className="wpmSub" style={{ display: "inline" }}>{fechaHoraAmPm(h.at)}</span> <b>{ACCION[h.action] || h.action}</b>
				{[quien, cambio, activa, h.reason ? "«" + h.reason + "»" : ""].filter(Boolean).map((t, i) => <span key={i}> · {t}</span>)}
			</div>
		);
	})}</>;
};

const DetalleCatalogo: React.FC<{ campusId: number; promo: Promo; promos: Promo[]; sym: string; hoy: string; canEdit: boolean; campuses: any[]; cursos: any;
	onClose: () => void; onCambiar: () => void; onChanged: () => void }> = ({ campusId, promo, promos, sym, hoy, canEdit, campuses, cursos, onClose, onCambiar, onChanged }) => {
	const [copiando, setCopiando] = useState<boolean>(false);
	const [activando, setActivando] = useState<boolean>(false);
	const [motivo, setMotivo] = useState<string>("");
	const [busy, setBusy] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const unaVez = useUnaALaVez();
	const p = promo;
	const r = p.rules || {};
	const otraAccion = p.active ? "Desactivar" : "Activar";

	const cambiarActiva = () => unaVez(async () => {
		if (motivo.trim().length < 10) return;
		try {
			setBusy(true); setError(null);
			await http.paymentService.savePromotion(campusId, payloadActivar(p, promos, !p.active, motivo.trim()));
			setActivando(false); setMotivo("");
			onChanged();
		} catch (e) {
			setError(serverError(e));
		} finally {
			setBusy(false);
		}
	});

	const vigencia = p.startsAt || p.endsAt
		? [p.startsAt ? "Desde " + fechaHoraAmPm(p.startsAt) : "", p.endsAt ? "Hasta " + fechaHoraAmPm(p.endsAt) : ""].filter(Boolean)
		: ["Estable"];

	return (
		<Ventana onClose={onClose} busy={busy} titulo={<>
			<span>{p.name}</span>
			<span className="waDescuentos"><Vigencia p={p} hoy={hoy} />{p.giftMissing ? <span className="wdChip wdChipOro">Sin Regalo</span> : null}</span>
		</>} pie={canEdit ? (activando ? <>
			<input className="form-control form-control-sm" style={{ flex: "1 1 260px", minHeight: 36 }} autoFocus value={motivo} disabled={busy} placeholder="Motivo (Mínimo 10 Letras)" onChange={(e) => setMotivo(e.target.value)} />
			<button type="button" className="btn btn-outline-secondary btn-sm" disabled={busy} onClick={() => { setActivando(false); setMotivo(""); }}>Atrás</button>
			<button type="button" className="btn btn-primary btn-sm" disabled={busy || motivo.trim().length < 10} onClick={cambiarActiva}>{busy ? "Guardando…" : "Sí, " + otraAccion}</button>
		</> : <>
			<button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => { setActivando(true); setCopiando(false); }}>{otraAccion}</button>
			<span style={{ flex: 1 }} />
			<button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => setCopiando(!copiando)}>Copiar</button>
			<button type="button" className="btn btn-primary btn-sm" onClick={() => { onClose(); onCambiar(); }}>Cambiar</button>
		</>) : null}>
			<div className="waDescuentos" style={{ maxWidth: "none" }}>
				{error ? <div className="alert alert-danger">{error}</div> : null}
				<div className="wcpAsiQuedaDetalle"><b>Así Queda</b> {frase(toDraft(p), sym, cursos?.courses || [])}</div>
				<div className="wpmDatos">
					<Dato t="Tipo">{TIPO_NOMBRE[tipoDe(p)]}</Dato>
					<Dato t="Qué Da">{valorTexto(p, sym)}</Dato>
					<Dato t="Vigencia">{vigencia.map((v) => <div key={v}>{v}</div>)}</Dato>
					<Dato t="La Da">{LA_DA[p.givenBy || "asesora"] || "-"}</Dato>
					<Dato t="Para Quién">{p.audience ? AUDIENCIAS[p.audience] || p.audience : "Todos"}</Dato>
					<Dato t="Cursos">{p.courseSummary || "Todos los cursos"}{r.monthsTotal && !r.monthsPaid ? <Sub>Solo Cursos de {r.monthsTotal} Meses</Sub> : null}</Dato>
					<Dato t="Acuerdos Vivos">{(p.liveAgreements || 0).toLocaleString("es-MX")}</Dato>
					<Dato t="Usos 30 Días">{(p.uses30 || 0).toLocaleString("es-MX")}{p.reserved30 ? <Sub>{p.reserved30 === 1 ? "1 Apartado" : p.reserved30 + " Apartados"}</Sub> : null}</Dato>
					<Dato t="Descontado 30 Días">{monto(sym, p.discounted30 || 0)}</Dato>
				</div>
				{p.conditions ? <Seccion t="Guía"><div style={{ fontSize: 14 }}>{p.conditions}</div></Seccion> : null}
				{copiando ? (
					<Seccion t="Copiar a Otros Planteles">
						<CopiarPromo campusId={campusId} promo={p} campuses={campuses} onDone={() => {}} />
					</Seccion>
				) : null}
				<Seccion t="Historial"><Historial campusId={campusId} promo={p} sym={sym} /></Seccion>
			</div>
		</Ventana>
	);
};

export default DetalleCatalogo;
